import {
  HeadingText,
  ParagraphText,
  ImageMessage,
} from '@leagueplatform/genesis-core';

interface ModalBodyProps {
  image: string;
  heading: string;
  paragraphs: string[];
}

export const ModalBody = ({ image, heading, paragraphs }: ModalBodyProps) => (
  <ImageMessage
    image={image}
    css={{
      flexGrow: 1,
      padding: '$two $none',
      textAlign: 'left',
      '@mobile': { padding: '$half' },
      '& p:not(:last-child)': { marginBlockEnd: '$half' },
    }}
  >
    <HeadingText
      level="3"
      size="lg"
      css={{
        paddingBlock: '$half',
      }}
    >
      {heading}
    </HeadingText>
    {paragraphs.map((text) => (
      <ParagraphText key={text}>{text}</ParagraphText>
    ))}
  </ImageMessage>
);
